module.exports = __webpack_public_path__ + "img/symbol_5.6adf6a71.png";